import { useSyncExternalStore } from 'react';
import { pluginRegistry } from '@/plugins/pluginRegistry';
import type { PluginGroup } from '@/plugins/types';

export function usePluginsByGroup(group: PluginGroup) {
  return useSyncExternalStore(
    (listener) => pluginRegistry.subscribe(listener),
    () => pluginRegistry.getPluginsByGroup(group),
    () => pluginRegistry.getPluginsByGroup(group)
  );
}
